/* eslint-disable */
import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';

@Component({
  selector: 'strategy-type',
  template: require('./strategy-type.component.html')
})
export class StrategyTypeComponent extends BaseRoute {
  constructor(injector: Injector) {
    super(injector);
  }

  descriptionModalOptionsMap = new Map([
    ['Core',
      '<h2 class="modal-sub-title">Core</h2><p class="content">Highly diversified across domestic, ' +
      'international and fixed-income assets. You can choose the amount of risk you are comfortable with, ' +
      'from conservative to aggressive.</p>'],
    ['Tax Optimized', '<h2 class="modal-sub-title">Tax Optimized</h2><p class="content">Typically suited for people ' +
      'who have investments in non-IRA taxable accounts, especially those in higher tax brackets. These portfolios ' +
      'include municipal bonds.</p>'],
    ['SRI', '<h2 class="modal-sub-title">Socially Responsible</h2><p class="content">Shaped by companies with ' +
      'ethical track records, you’ll only invest in businesses that actively practice sustainability, energy ' +
      'efficiency or other environmentally-friendly initiatives.</p>'],
    ['Income', '<h2 class="modal-sub-title">Income</h2><p class="content">Ideal if you are currently near or in ' +
      'retirement. This portfolio type offers higher dividend yields, while maintaining a more conservative risk ' +
      'profile.</p>']
  ]);

  ngOnInit() {
    const goalSession = this.flowManager.goalSession;

    // isDirty: Flag to get recommendation
    // useInitialLoader: Flag to make first arrival to recommendation page
    // use different kind of loading effect. UI/UX ask
    this.flowManager.goalSession = { ...this.flowManager.goalSession, isDirty: true, useInitialLoader: true };

    // If no goal session, default to free strategies
    if (!goalSession) {
      this.removePaidStrategies(true)
    }

    // Depending on the goal session values at this step, either 2, 3, or 4 portfolio strategies can be displayed
    if (goalSession) {
      // If the user navigates back to the questions after making a choice
      // on the recommendation page then we need to account for what their vested status is
      // when displaying strategies to pick from
      if (goalSession.cashAllocation === 'cashEnhanced') {
        // Remove paid strategies
        this.removePaidStrategies(true)
      } else {
        // Remove free strategies
        this.removePaidStrategies(false);
      }
      // Only display Income portfolio when there is GoalType of 'Income'
      if (goalSession.goal !== 'income') {
        this.removeStrategyOption('Income')
      }
      // Only display Tax-Optimized when there is an AccountTaxType of 'Taxable'
      if (goalSession.accountTaxType !== 'taxable') {
        this.removeStrategyOption('Tax Optimized')
      }
      // if the person's goal has changed then we need to reset their strategy if it's no longer an option
      // if the strategy in goal session is not an option then set it to null in goalSession
      // otherwise do nothing
      if (goalSession.strategy) {
        if (this.form.inputs.strategy.options.findIndex(x => x.value === goalSession.strategy) === -1) {
          this.appActions.setData('goalSession.strategy', null);
        }
      }
    }
    // Update form modal content
    this.descriptionModalOptionsMap.forEach(x => {
      this.form.descriptionModal.modalContent.content += x;
    });
  }

  // Remove strategies based on goal type
  // updates form options AND modal display
  removeStrategyOption(indexName: string) {
    this.descriptionModalOptionsMap.delete(indexName);
    const index = this.form.inputs.strategy.options.findIndex(x => x.name === indexName);
    if (index !== -1) {
      this.form.inputs.strategy.options.splice(index, 1);
    }
  }

  // All options are passed from node but then need to swap between free and paid
  // based on the cashVested status of the user
  removePaidStrategies(isCashVested: boolean) {
    this.form.inputs.strategy.options = this.form.inputs.strategy.options.filter(x => x.isCashVested === isCashVested);
  }

  updateOptionValue(event) { }

}
